import { render, staticRenderFns } from "./couponBatch.vue?vue&type=template&id=eec36424&scoped=true"
import script from "./couponBatch.vue?vue&type=script&lang=js"
export * from "./couponBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec36424",
  null
  
)

export default component.exports